enum activateStatusEnum {
	OK = 'OK',
	ACTIVATION_CODE_KO = 'WRONG_ACTIVATION_CODE',
	EMAIL_ACTIVATION_KO = 'EMAIL_ALREADY_EXIST'
}

export default activateStatusEnum
